import { Text } from "@shopify/polaris"

import { PaymentChildrenFeatureItem } from "@/pages/Plan/component/PaymentChildren"

export type DowngradeFeature = {
  text: string
  tooltipContent?: string
  withoutFeature?: boolean
}

const DowngradePanel = (props: {
  features?: DowngradeFeature[]
  effectiveDateText?: string
  title?: string
}) => {
  const { features, effectiveDateText, title } = props

  if (!features?.length) return null

  return (
    <div className="space-y-3">
      {effectiveDateText ? (
        <Text variant="bodyMd" as="p">
          {effectiveDateText}
        </Text>
      ) : null}
      <div className="space-y-3">
        <Text variant="bodyMd" as="p" fontWeight="medium">
          {title || t("TheseFeaturesWillBePausedAfterDowngrading")}
        </Text>
        <div className={"grid grid-cols-2 gap-x-4 gap-y-2"}>
          {features.map((item) => (
            <PaymentChildrenFeatureItem
              key={item.text}
              text={item.text}
              tooltipContent={item.tooltipContent}
              withoutFeature
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default DowngradePanel
